"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UITypeahead = _interopRequireDefault(require("UIComponents/typeahead/UITypeahead"));

var _sidebarUtils = require("../utils/sidebarUtils");

var _searchBarUtils = require("../utils/searchBarUtils");

var _requestStatus = require("../constants/propTypes/requestStatus");

var _requestStatus2 = require("../utils/requestStatus");

var _default = _react.default.createClass({
  displayName: "SearchBar",
  propTypes: {
    allProviders: _react.PropTypes.array.isRequired,
    appliedSearchTerm: _react.PropTypes.string.isRequired,
    autocomplete: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
    categoryFilter: _react.PropTypes.string.isRequired,
    debouncedFetchForAutocomplete: _react.PropTypes.func.isRequired,
    fetchProviders: _react.PropTypes.func.isRequired,
    goodFilters: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
    onFilterByNameSelection: _react.PropTypes.func.isRequired,
    onGoodSelection: _react.PropTypes.func.isRequired,
    onSidebarFilterSelection: _react.PropTypes.func.isRequired,
    providersRequestStatus: _requestStatus.requestStatusPropType.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      searchTerm: this.props.appliedSearchTerm
    };
  },
  handleInputChange: function handleInputChange(event) {
    var _this$props = this.props,
        debouncedFetchForAutocomplete = _this$props.debouncedFetchForAutocomplete,
        onFilterByNameSelection = _this$props.onFilterByNameSelection;
    this.setState({
      searchTerm: event.target.value
    });
    var trimmedSearchTerm = (0, _searchBarUtils.getTrimmedSearchTerm)(event.target.value);

    if (trimmedSearchTerm === '') {
      onFilterByNameSelection(trimmedSearchTerm);
    } else {
      debouncedFetchForAutocomplete(trimmedSearchTerm);
    }
  },
  handleInputFocus: function handleInputFocus() {
    var _this$props2 = this.props,
        fetchProviders = _this$props2.fetchProviders,
        providersRequestStatus = _this$props2.providersRequestStatus;

    if ((0, _requestStatus2.isUninitialized)(providersRequestStatus)) {
      fetchProviders();
    }
  },
  handleOptionSelection: function handleOptionSelection(event) {
    var selectedValue = event.target.value;

    if (this.isSpecificGoodSelected(selectedValue)) {
      this.props.onGoodSelection(selectedValue);
      return;
    }

    if ((0, _searchBarUtils.isSidebarFilterType)(selectedValue)) {
      this.setState({
        searchTerm: ''
      });
      this.props.onSidebarFilterSelection(selectedValue);
      return;
    }

    this.setState({
      searchTerm: selectedValue
    });
    this.props.onFilterByNameSelection((0, _searchBarUtils.getTrimmedSearchTerm)(selectedValue));
  },
  isSpecificGoodSelected: function isSpecificGoodSelected(selectedValue) {
    return this.props.autocomplete.getIn(['resultsIndex', selectedValue]);
  },
  getPlaceholder: function getPlaceholder() {
    var categoryFilter = this.props.categoryFilter;

    if (!categoryFilter || categoryFilter === 'all-products') {
      return (0, _unescapedText.default)('header.searchPlaceholder.ALL');
    } else {
      var filterCategory = (0, _sidebarUtils.getCategoryMenuOptions)(categoryFilter).parent;
      return (0, _unescapedText.default)("header.searchPlaceholder." + filterCategory);
    }
  },
  render: function render() {
    var _this$props3 = this.props,
        allProviders = _this$props3.allProviders,
        appliedSearchTerm = _this$props3.appliedSearchTerm,
        autocomplete = _this$props3.autocomplete,
        goodFilters = _this$props3.goodFilters;
    var suggestedFilters = (0, _searchBarUtils.getNameAndSidebarFilterOptions)(this.state.searchTerm, goodFilters, allProviders, autocomplete.get('resultsToDisplay').size);
    return _react.default.createElement(_UITypeahead.default, {
      autoFilter: false,
      className: "search-bar-and-results",
      hideResults: !autocomplete.get('showMenu') || !this.state.searchTerm && !appliedSearchTerm,
      onChange: this.handleOptionSelection,
      onFocus: this.handleInputFocus,
      onSearchChange: this.handleInputChange,
      options: [{
        options: suggestedFilters.toJS(),
        text: (0, _unescapedText.default)('MarketplaceUI.searchBar.suggestedFiltersText')
      }, {
        options: autocomplete.get('resultsToDisplay').toJS(),
        text: (0, _unescapedText.default)('MarketplaceUI.searchBar.displayedResultsText')
      }],
      search: this.state.searchTerm,
      resultsClassName: "search-results",
      searchClassName: "search-bar",
      placeholder: this.getPlaceholder()
    });
  }
});

exports.default = _default;
module.exports = exports.default;